import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Types from '../Actions/Types'

export const INITIAL_STATE = Immutable({ 
    vaccineList: {
        loaded: false,
        isLoading: false,
        data: []
    }
}) 

const responseVaccineList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            vaccineList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            vaccineList: {
                isLoading: false
            }
        })
    }
};

const ACTION_HANDLERS = {
    [Types.RESPONSE_VACCINATION]: responseVaccineList
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/Reducers/MetadataReducer.js